<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      stroke="currentColor"
      stroke-miterlimit="10"
      stroke-width="2"
      d="M8 21h8.25M8 16.5h4.5M8 12h8.25M8 7.5h4.5M8 3h8.25"
    />
  </svg>
</template>

<script>
export default {};
</script>
